transfers<template lang="pug">
  .crud
    modal-import(model="transfers")
    modal-transfers(:form='form', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.transfers') }}:
            span {{ $t('strings.description', {attribute: $t('strings.transfers')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="plus" @click="addRecord") {{ $t('strings.add') }}
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected"  max-height="350px" :data="transfers" )
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
                .d-flex.justify-content-between(@click="loadCatalogsFilters()")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="cleanFilters") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('transfers.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('branches.branch_origin')" v-model="filters.whereIn.branch_origin_id")
                          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in branches")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('branches.branch_destination')" v-model="filters.whereIn.branch_destination_id")
                          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in branches")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('transfers.status_transfer')" v-model="filters.whereIn.status_transfer_id")
                          vm-select-item(:key="index" :value="item.id" :text="$t('transfers.'+item.name)" v-for="(item,index) in statusesTransfers")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('transfers.status_reception')" v-model="filters.whereIn.status_reception_id")
                          vm-select-item(:key="index" :value="item.id" :text="$t('transfers.'+item.name)" v-for="(item,index) in statusesReceptions")
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('transfers.'+ item)")
                    vm-order-by-item(value='folio,asc' :text="$t('transfers.folio')" direction='down')
                    vm-order-by-item(value='folio,desc' :text="$t('transfers.folio')" direction='up')
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list" style="display: none;")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('transfers.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data" @click="goDetail(tr)")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  .details(@click="goDetail(data[indextr])")
                    slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                    slot(v-if="column != 'status_reception' && column != 'status_transfer' && column != 'created_at'") {{data[indextr][column]}}
                    vm-status-indicator(v-if="column == 'status_reception'" :color="colorStatus(data[indextr][column])" :pulse="data[indextr]['statu_reception_id'] !== 2") {{$t('transfers.'+data[indextr][column])}}
                    vm-status-indicator(v-if="column == 'status_transfer'"  :color="colorStatus(data[indextr][column])" :pulse="data[indextr]['status_transfer_id'] !== 3") {{$t('transfers.'+data[indextr][column])}}
                vm-td
                  vm-dropdown(v-if="tr.status_transfer_id != 4" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(v-if="tr.quantity_details == 0 && tr.status_transfer_id == 1" @click="editRecord(data[indextr], tr)")
                        vm-icon(icon="edit-2-outline")
                        slot &nbsp;{{ $t('strings.edit') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="tr.quantity_details > 0 && tr.status_transfer_id == 1" @click="setApproved(data[indextr], tr)")
                        vm-icon(icon="checkmark-circle-outline")
                        slot &nbsp;{{ $t('transfers.approve') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="tr.status_transfer_id == 1" @click="goExcel(data[indextr], tr)")
                        vm-icon(icon="plus-outline")
                        slot &nbsp;{{ $t('transfers.add_products_with_excel') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="tr.quantity_details > 0" @click="printTags(data[indextr], tr)")
                        vm-icon(icon="printer-outline")
                        slot &nbsp;{{ $t('transfers.print_tags') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="tr.status_transfer_id == 5" @click="disapprove(data[indextr], tr)")
                        vm-icon(icon="alert-circle-outline")
                        slot &nbsp;{{ $t('strings.disapprove') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="tr.status_transfer_id != 4" @click="cancel(data[indextr], tr)")
                        vm-icon(icon="close-outline")
                        slot &nbsp;{{ $t('strings.cancel') }}
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Transfers')
const { mapActions: mapActionsLG } = createNamespacedHelpers('LabelGroups')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalTransfers = () => import('@/components/modals/ModalTransfers.vue')

export default {
  name: 'Transfers',
  components: {
    ModalImport,
    ModalTransfers
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['folio', 'origin', 'destination', 'status_transfer', 'status_reception', 'comments', 'created_at'],
    columnsOrderBy: [],
    attributeModal: '',
    status: {
      in_progress: '',
      shipment: '#ff9900',
      scanned: '#28A745',
      approved: '#00c4ff',
      pending: '',
      in_complete: '#ff9900',
      complete: '#28A745',
      canceled: '#FF0000'
    },
    filters: {
      where: {
        folio: '',
        param: ''
      },
      whereIn: {
        branch_origin_id: [],
        branch_destination_id: [],
        status_transfer_id: [1, 2, 3, 5],
        status_reception_id: []
      },
      whereBetween: {
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['transfers', 'branches', 'pagination', 'filterParams', 'statusesTransfers', 'statusesReceptions']),
    ...configMapGetters(['isSFS'])
  },
  methods: {
    ...mapActions([
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadRecords',
      'getBranches',
      'getStatusesTransfers',
      'getStatusesReceptions',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'applyFilter',
      'clearFilter',
      'sendAlertWithoutDetails',
      'printTag',
      'changeStatusToShipment',
      'changeStatusToApproved',
      'changeStatusToCanceled',
      'changeStatusToPending'
    ]),
    ...mapActionsLG([
      'addLabelsFromTransfers',
      'setLoader'
    ]),
    async getRecords (page) {
      this.applyFilter(this.filters)
      let t = this
      await this.loadRecords({ page }).then(data =>
        t.getProps(t.$route.params.id)
      )
    },
    colorStatus (code) {
      return this.status[code] || ''
    },
    cleanFilters () {
      this.filters.whereIn = {
        branch_origin_id: [],
        branch_destination_id: [],
        status_transfer_id: [],
        status_reception_id: []
      }
      this.filters.betweenDates = {
        created_at: []
      }
    },
    async loadCatalogsFilters () {
      if (this.branches.length === 0) await this.getBranches()
      if (this.statusesTransfers.length === 0) await this.getStatusesTransfers()
      if (this.getStatusesReceptions.length === 0) await this.getStatusesReceptions()
    },
    goExcel (record) {
      this.$router.push(`/transfers/${record.id}/tab`)
    },
    goDetail (record) {
      if (record.quantity_details) {
        this.$router.push(`/transfers/${record.id}/detail`)
      } else {
        this.sendAlertWithoutDetails()
      }
    },
    setApproved (record) {
      this.changeStatusToApproved({ id: record.id })
    },
    async printTags (record) {
      await this.addLabelsFromTransfers({ ids: [record.id], folio: record.folio })
      this.setLoader(false)
      this.$router.push(`/label_groups`)
    },
    cancel (record) {
      this.changeStatusToCanceled({ id: record.id })
    },
    disapprove (record) {
      this.changeStatusToPending({ id: record.id })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
